import { WHY_CHOOSE_CARS_LIST } from "../../contants";

// eslint-disable-next-line import/prefer-default-export
export const getWhychooseCars = (data) => ({
    type: WHY_CHOOSE_CARS_LIST,
    payload: data
});
